import * as React from 'react';
import PropTypes from 'prop-types';
import Box from "@mui/material/Box";
import {CircularProgress, Typography} from "@mui/material";

function UploadMediaLoading(
    {

    }
) {
    return (
        <Box
            sx={{
                textAlign: 'center',
                height: "65vh",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            <CircularProgress
                size={'4em'}
                sx={{
                    mb: 2,
                }}
            />
            <Typography
                variant={'h3'}
            >
                We are uploading the new data...
            </Typography>
        </Box>
    )
}

export default UploadMediaLoading;
